<template>
  <div class="fact-panel" v-bind:class="{'map-highlight': isMapHighlighted}">
    <transition name="fact-panel-fade">
      <div class="fact-container" v-if="fact && detailedView"  style="background:black;">
        <div v-if="fact.hasCover" class="map-bg fade-slowly" v-bind:style="bgMap"/>
        <div class="fact">
          <div class="margin-div"/>
          <div class="fact-body" v-bind:class="{bgnone:!detailedView}">
            <div class="fact-head" >
              <span class="fact-year" >{{fact.year}}</span>
              <!--<div class='fact-compass' ></div>-->
              <!--
              <div class="fact-scale" >
              <span>20km / 13.7 mi</span>
              <div class="scale-line"><div></div></div>
            </div>
          -->
        </div>
        <span class="fact-title">{{fact.title}}</span>
        <span class="fact-text fade-slowly" style="transition-delay:0.4s;" v-bind:style="{'opacity':slowFadeOpacity}">{{fact.text}}</span>
      </div>
    </div>

    <div class="fact-footer fade-slowly" v-bind:style="{'opacity':slowFadeOpacity}">

      <social-sharing v-bind:url="baseURL+'/commissions/european-motorways-1920-2020/'+fact.year+'/'"
      v-bind:title="fact.title"
      v-bind:description="fact.year+'–'+fact.text"
      inline-template>
      <div class="fact-share">
        <a><network network="facebook"><img src="@/assets/icons/share-fb.svg"/></network></a>
        <a><network network="twitter"><img src="@/assets/icons/share-tw.svg"/></network></a>
      </div>
    </social-sharing>
    <div v-if="fact.distance" class="small-text">{{(fact.distance).toLocaleString('en-US')}} km / {{Number.parseFloat((fact.distance*0.6213).toFixed(1)).toLocaleString('en-US')}} mi</div>
    <div class="small-text" v-if="fact.cities">{{fact.cities}}</div>
    <img class="badge" v-if="fact.hasBadge" :src="require('@/assets/badges/'+fact.year+'.svg')" onerror="this.style.display='none'"/>

    <!--
    v-bind:quote="Vue is a progressive framework for building user interfaces."
    hashtags="vuejs,javascript,framework"
    twitter-user="vuejs"
  -->














</div>
<a class="quit-button" @click="detailedView=false">
  <img src="@/assets/icons/quit.svg" />
</a>
</div>
</transition>

<transition name="fact-panel-fade">
  <div class="fact-container" v-if="fact && !detailedView">
    <div class="fact">
      <div class="margin-div"/>
      <div class="fact-body" v-bind:class="{bgnone:!detailedView}">
        <div class="fact-head" >
          <span class="fact-year" >{{fact.year}}</span>
        </div>
        <span class="fact-title">{{fact.title}}</span>
        <button class="desktop" @click="detailedView=!detailedView;"><span>Read more</span></button>
        <button class="mobile" @click="visibleFactYear = fact.year; $router.push({ path: 'facts' })"><span>Read more</span></button>
      </div>
    </div>
  </div>
</transition>
</div>
</template>

<script>
// @ is an alias to /src
import {mapGetters} from 'vuex';

export default {
  name: 'factpanel',
  data() {
    return {
      slowFadeOpacity: 0,
      publicPath: process.env.BASE_URL
    }
  },
  watch: {
    detailedView: function(d){
      setTimeout(()=>{
        if(d)this.slowFadeOpacity = 1
        else this.slowFadeOpacity = 0
      }, 200);
    }
  },
  components: {

  },
  computed:{
    ...mapGetters(['factIndex', 'year', 'baseURL']),
    detailedView:{
      get() { return this.$store.state.detailedView; },
      set(p) { this.$store.commit('setDetailedView', p); },
    },
    playing:{
      get() { return this.$store.state.playing; },
      set(p) { this.$store.commit('setPlaying', p); },
    },
    bgMap: function(){
      if(this.detailedView){
        return {opacity: this.slowFadeOpacity, background: "url("+require("@/assets/imgs/facts/facts_"+this.fact.year+".jpg")+")"};
      }
      return {};
    },
    isMapHighlighted: function(){
      return ((this.year >=1975 && this.year<=1980) || (this.year >=1994 && this.year<=1999) || (this.year >=2013) )
    },
    visibleFactYear: {
      get() { return this.$store.state.visibleFactYear; },
      set(d) { this.$store.commit('setVisibleFactYear', d); },
    },
  },
  props: ['fact'],

  mounted: function(){
    document.getElementById('scroll-area').addEventListener('click', () =>{
      this.detailedView = false;
    });
  }
}
</script>
<style  lang="scss">
.fact-panel{
  position:fixed;
  z-index:3;
}
.fact{
  display: flex;
  flex-direction: column;
  position:relative;
}

.fact-footer{
  .badge{
    margin-right: 1em;
    width: auto !important;
    height: 2.0em;
  }
  .small-text{
    flex-grow:1;
    line-height: 3.3em;
  }
  .fact-share{
    margin-top:0.25em;
  }
}
.map-bg{
  position:absolute;
  z-index: 0!important;
  left:0px;
  top:0px;
  width: 100%;
  height:100%;
  background-size: 100% auto !important;
  background-repeat: no-repeat !important;
}

.fade-slowly{
  transition-delay: 0.2s;
  transition: opacity 0.5s ease-in-out;
}

.fact-container >*{
  z-index:1;
}
.fact-container{
  position:fixed;
  right:0px;
  top:0px;
  width: 502px;
  height:100vh;
  min-width: 250px;
  max-width: 502px;
}

.fact-body{
  padding:1.63em;
  box-sizing: border-box;
  padding-bottom:5em;
  /*display:table-row;*/
  background-image: linear-gradient(rgba(0, 0, 0, 0.0), rgba(0, 0, 0, 1.0) 200px);
  /*position:relative;*/
  flex: 1 1 auto;
}

.fact-head{
  height: 1.85em;
}

.fact-head *{
  vertical-align: middle;
}

.fact-year{
  font-size: 1em;
  color:#ff6063;
  text-align: left;
  line-height: 2.0;
}

.fact-title{
  margin-top:1em;
  display:block;
  font-size: 1.63em;
  text-align: left;
  font-weight: lighter;
}

.fact-text{
  margin-top:0.85em;
  display:block;
  font-size: 1em;
  text-align: left;
  padding-bottom:1.5em;
  line-height: 1.4;
}

.fact-compass{
  background: url(../assets/icons/fact-compass.svg);
  height:1.33em;
  width:1.33em;
  min-height: 25px;
  min-width: 25px;
  background-repeat: no-repeat;
  float: right;
  margin-left:0.5em;
  margin-top:-0.0em;
}

.fact-image{
  position:absolute;
  left:0px;
  top:0px;
  height:100%;
  width:100%;
  z-index:0;
}

.fact-scale{
  font-size: 0.57em;
  font-weight: lighter;
  color: #707070;
  float:right;
  text-align:center;
  white-space: nowrap;
}

.scale-line{
  border-bottom: 2px solid #707070;
  border-left: 2px solid #707070;
  border-right: 2px solid #707070;
  margin-top:0.6em;
  height: 5px;
  margin-left: auto;
  margin-right: auto;
  width: 3vw;
}

.fact-footer-mobile{
  position:absolute;
  padding-bottom:1.63em;
  bottom:0px;
  left:0px;
  padding-left:1.63em;
  padding-right:1.63em;
  width: 100%;
  box-sizing: border-box;
  display: table;
  vertical-align: bottom;
  horizontal-align:right;
  line-height:1.0;
}


.fact-footer{
  position:absolute;
  background-image: linear-gradient(rgba(0, 0, 0, 0.0), rgba(0, 0, 0, 1.0) 3rem);
  padding-bottom:1.63em;
  padding-top:2.5em;
  bottom:0px;
  left:0px;
  padding-left:1.63em;
  padding-right:1.63em;
  width: 100%;
  box-sizing: border-box;
  display:flex;
  flex-direction: row-reverse;
  justify-content: space-between;
  line-height:1.5em;
}

.fact-footer *{
  height:1.5em;
}

.fact-share img:hover{
  filter:brightness(4);
}
.fact-share img{
  margin-left:0.8em;
  min-width: 25px;
}

.margin-div{
  height:42vh;
  min-height:300px;
  max-height:760px;
  width:100%;
}

.fact-panel-fade-enter-active, .fact-panel-fade-leave-active {
  transition: opacity 0.54s;
}

.fact-panel-fade-enter, .fact-panel-fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

.bgnone{
  background: none;
}

.fact{
  height:100%;
  overflow-y: scroll;
}

.fact-body button{
  border: 1px solid white;
  background: transparent;
  border-radius: 0.91em;
  color: white;
  width: 7.62em;
  height: 1.82em;
  font-weight: lighter;
  font-size: 0.85em;
  margin-top: 1.85em;
  margin-bottom:3.5em;
  text-align: center;
  span{
    width:100%;
  }
}
.fact-panel.map-highlight *{
  background:transparent!important
}
</style>
